import { render } from "./HorizontalBannerTopLatest.vue?vue&type=template&id=21499409"
import script from "./HorizontalBannerTopLatest.vue?vue&type=script&lang=js"
export * from "./HorizontalBannerTopLatest.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/dev-nextgen-services-mvn-tf@4/discovery-ui-web/public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__